// src/app/shared/services/canonical.service.ts
import { Injectable, Inject, Renderer2, RendererFactory2 } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Injectable({ providedIn: "root" })
export class CanonicalService {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private rendererFactory: RendererFactory2,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  setCanonicalAndHreflangs(currentLang: string) {
    const baseUrl = "https://brightfunded.com";
    const supportedLangs = ["en", "es", "de", "pl"];

    const currentUrl = currentLang === "default" ? `${baseUrl}/` : `${baseUrl}/${currentLang}/`;

    this.removeLink("canonical");

    const canonical = this.renderer.createElement("link");
    canonical.setAttribute("rel", "canonical");
    canonical.setAttribute("href", currentUrl);
    this.renderer.appendChild(this.doc.head, canonical);

    this.removeLinks("alternate");

    supportedLangs.forEach((lang) => {
      const alt = this.renderer.createElement("link");
      alt.setAttribute("rel", "alternate");
      alt.setAttribute("hreflang", lang);
      alt.setAttribute("href", `${baseUrl}/${lang}/`);
      this.renderer.appendChild(this.doc.head, alt);
    });

    const xDefault = this.renderer.createElement("link");
    xDefault.setAttribute("rel", "alternate");
    xDefault.setAttribute("hreflang", "x-default");
    xDefault.setAttribute("href", `${baseUrl}/`);
    this.renderer.appendChild(this.doc.head, xDefault);
  }

  private removeLink(rel: string) {
    const element = this.doc.querySelector(`link[rel='${rel}']`);
    if (element) {
      this.renderer.removeChild(this.doc.head, element);
    }
  }

  private removeLinks(rel: string) {
    const elements = this.doc.querySelectorAll(`link[rel='${rel}']`);
    elements.forEach((el) => {
      this.renderer.removeChild(this.doc.head, el);
    });
  }
}
